<script>
  import { onMount } from "svelte";

  let svg;
  let width = 0;
  let height = 0;


</script>


<div class="continer" bind:offsetWidth="{width}" bind:offsetHeight="{height}">
  <svg bind:this="{svg}" viewBox="0 0 {width} {height}" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1.5">
    <defs>
      <symbol id="tile" viewBox="0 0 768 768">
        <g>
          <path fill="#ff0000" stroke="#000" style="fill: var(--outer); stroke-width: 20px;" d="M0 0h768v768H0z"/>
          <path fill="#ff0000" stroke="#000" style="fill: var(--middle)" d="M109.57 109.57h548.85v548.85H109.57z"/>
          <path fill="#ff0000" stroke="#000" style="fill: var(--inner)" d="M165.84 165.84h436.32v436.32H165.84z"/>
          <circle cx="384" cy="384" r="38.89" fill="#d4dbbb" stroke="#000" style="fill: var(--dot)"/>
          <path stroke="#000" fill="#ff0000" style="fill: var(--petal)" d="M331.18 339.31c-19.5 15.65-74.1-2.2-93.3-30.33-38.52-56.41 18.29-33.2 29.96-41.57 9.3-6.67-17.14-78.34 52.33-23.61 26.28 20.7 34.58 76.6 11 95.51z"/>
          <path stroke="#000" fill="#ff0000" style="fill: var(--petal)" d="M339.31 436.82c15.65 19.5-2.2 74.1-30.33 93.3-56.41 38.52-33.2-18.29-41.57-29.96-6.67-9.3-78.34 17.14-23.61-52.33 20.7-26.29 76.6-34.58 95.51-11z"/>
          <path stroke="#000" fill="#ff0000" style="fill: var(--petal)" d="M436.82 428.69c19.5-15.65 74.1 2.2 93.3 30.33 38.52 56.41-18.29 33.2-29.96 41.57-9.3 6.67 17.14 78.34-52.33 23.61-26.29-20.7-34.58-76.6-11-95.51z"/>
          <path stroke="#000" fill="#ff0000" style="fill: var(--petal)" d="M428.69 331.18c-15.65-19.5 2.2-74.1 30.33-93.3 56.41-38.52 33.2 18.29 41.57 29.96 6.67 9.3 78.34-17.14 23.61 52.33-20.7 26.28-76.6 34.58-95.51 11z"/>

        </g>
      </symbol>
    
      <pattern id="Pattern" x="-50" y="-50" width="200" height="200" patternUnits="userSpaceOnUse">
        <use xlink:href="#tile" height="100" width="100" class="color1" />
        <use xlink:href="#tile" height="100" width="100" x="100" class="color2" />
        <use xlink:href="#tile" height="100" width="100" y="100" class="color2" />
        <use xlink:href="#tile" height="100" width="100" x="100" y="100" class="color1" />
      </pattern>
  </defs>
    <rect fill="url(#Pattern)" width="{width}" height="{height}"/>

    <style>
      svg {
        stroke-width: 10px;
      }

      .color1 {
        --outer: #85a9b1;
        --middle: #d4dbbb;
        --inner: #ebddbf;
        --dot: #d4dbbb;
        --petal: #24347c;
      }
      .color2 {
        --outer: #3D3D3D;
        --middle: #F7B9B6;
        --inner: #ECDEBD;
        --dot: #D4B474;
        --petal: #24347c;
      }
    </style>
  </svg>
</div>

<style>
  .continer {
    width: 100%;
    height: 100%;
  }
</style>